export * from "./src/utils/errors";
export * from "./src/action";

export * as draft from "./src/draft";
export * as draftEdit from "./src/draftEdit";
export * as inboxSection from "./src/inboxSection";
export * as invitations from "./src/invitations";
export * as message from "./src/message";
export * as notification from "./src/notification";
export * as tag from "./src/tag";
export * as thread from "./src/thread";
export * as threadRequest from "./src/threadRequest";
export * as toggleFocusMode from "./src/toggleFocusMode";
export * as updateTagSubscription from "./src/updateTagSubscription";
export * as updateThreadSubscription from "./src/updateThreadSubscription";
export * as updateUserSettings from "./src/updateUserSettings";
export * as user from "./src/user";
export * as userPushNotificationSubscription from "./src/userPushNotificationSubscription";

export * as draftAuthorizers from "./src/authorizers/draftAuthorizers";
export * as genericAuthorizers from "./src/authorizers/genericAuthorizers";
export * as inboxAuthorizers from "./src/authorizers/inboxAuthorizers";
export * as messageAuthorizers from "./src/authorizers/messageAuthorizers";
export * as notificationAuthorizers from "./src/authorizers/notificationAuthorizers";
export * as organizationAuthorizers from "./src/authorizers/organizationAuthorizers";
export * as tagAuthorizers from "./src/authorizers/tagAuthorizers";
export * as threadAuthorizers from "./src/authorizers/threadAuthorizers";

/* -------------------------------------------------------------------------------------------------
 *  Actions Map
 * -------------------------------------------------------------------------------------------------
 */
import type { ActionCreator } from "./src/action";

import * as draft from "./src/draft";
import * as draftEdit from "./src/draftEdit";
import * as inboxSection from "./src/inboxSection";
import * as invitations from "./src/invitations";
import * as message from "./src/message";
import * as notification from "./src/notification";
import * as tag from "./src/tag";
import * as thread from "./src/thread";
import * as threadRequest from "./src/threadRequest";
import * as toggleFocusMode from "./src/toggleFocusMode";
import * as updateTagSubscription from "./src/updateTagSubscription";
import * as updateThreadSubscription from "./src/updateThreadSubscription";
import * as updateUserSettings from "./src/updateUserSettings";
import * as user from "./src/user";
import * as userPushNotificationSubscription from "./src/userPushNotificationSubscription";

const allActions = [
  ...Object.values(draft.actions),
  ...Object.values(draftEdit.actions),
  ...Object.values(inboxSection.actions),
  ...Object.values(invitations.actions),
  ...Object.values(message.actions),
  ...Object.values(notification.actions),
  ...Object.values(tag.actions),
  ...Object.values(thread.actions),
  ...Object.values(threadRequest.actions),
  ...Object.values(toggleFocusMode.actions),
  ...Object.values(updateTagSubscription.actions),
  ...Object.values(updateThreadSubscription.actions),
  ...Object.values(updateUserSettings.actions),
  ...Object.values(user.actions),
  ...Object.values(userPushNotificationSubscription.actions),
];

const actionNames = new Set<string>();

export const Actions = Object.fromEntries(
  allActions.map((action) => {
    if (actionNames.has(action.name)) {
      throw new Error(`[Actions] two actions have the same name: ${action.name}`);
    }

    actionNames.add(action.name);

    return [action.name, action as ActionCreator<unknown>];
  }),
);
